import React, { useContext, useState } from 'react';
import { makeStyles } from '@ellucian/react-design-system/core';
import { colorBrandNeutral500 } from '@ellucian/react-design-system/core/styles/tokens';
import { Snackbar, Button } from '@ellucian/react-design-system/core';
import { FormattedMessage } from 'react-intl';
const useStyles = makeStyles({
    name: 'SnackbarContext'
})(() => ({
    snackbarBtn: {
        '&:hover': {
            background: `${colorBrandNeutral500} !important`            
        }
    }
}));

const SnackbarContext = React.createContext({
    close: () => {},
    message: '',
    open: false,
    show: () => {},
    success: () => {},
    error: () => {},
    warning: () => {},
    info: () => {},
    variant: 'error',
});
const InnerSnackbar = () => {
    const { classes } = useStyles();
    const ctx = useContext(SnackbarContext);
    return (
        <Snackbar
            onClose={() => ctx.close()}
            open={ctx.open}
            message={ctx.message}
            variant={ctx.variant}
            ContentProps={{
                'aria-describedby': ctx.message,
            }}
            action={
                <Button
                    className={classes.snackbarBtn}
                    tabIndex={0}
                    variant="text"
                    withDarkBackground={true}
                    onClick={ctx.close}
                >
                    <FormattedMessage id="snackbarOk" />
                </Button>
            }
        />
    );
};
const SnackbarProvider = props => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [variant, setVariant] = useState('error');
    const value = {
        close: () => {
            setOpen(false);
            setMessage('');
        },
        message,
        open,
        variant,
        show: message => {
            setMessage(message);
            setVariant('error');
            setOpen(true);
        },
        success: message => {
            setMessage(message);
            setVariant('success');
            setOpen(true);
        },
        error: message => {
            setMessage(message);
            setVariant('error');
            setOpen(true);
        },
        warning: message => {
            setMessage(message);
            setVariant('warning');
            setOpen(true);
        },
        info: message => {
            setMessage(message);
            setVariant('info');
            setOpen(true);
        },
    };
    return (
        <SnackbarContext.Provider value={value}>
            {props.children}
            <InnerSnackbar />
        </SnackbarContext.Provider>
    );
};
const useSnackbar = () => {
    const ctx = useContext(SnackbarContext);
    if (ctx === undefined) {
        throw new Error('useSnackbar must be used within a SnackbarProvider');
    }
    return ctx;
};
export { SnackbarProvider, useSnackbar };
